import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Package, Clock, CheckCircle, XCircle, ArrowLeft } from 'lucide-react';

const Dashboard = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem('user'));
    if (!currentUser) {
      navigate('/login');
      return;
    }
    setUser(currentUser);

    const allOrders = JSON.parse(localStorage.getItem('orders') || '[]');
    const userOrders = allOrders.filter(order => order.userId === currentUser.id);
    setOrders(userOrders);
  }, [navigate]);

  const statusText = {
    pending: 'Onay Bekliyor',
    approved: 'Onaylandı',
    rejected: 'Reddedildi'
  };

  const statusIcon = {
    pending: <Clock className="w-5 h-5 text-yellow-500" />,
    approved: <CheckCircle className="w-5 h-5 text-green-500" />,
    rejected: <XCircle className="w-5 h-5 text-red-500" />
  };

  const statusColor = {
    pending: 'bg-yellow-500/10 text-yellow-500 border-yellow-500/30',
    approved: 'bg-green-500/10 text-green-500 border-green-500/30',
    rejected: 'bg-red-500/10 text-red-500 border-red-500/30'
  };

  if (!user) return null;

  return (
    <div className="min-h-screen bg-gradient-to-b from-black via-gray-900 to-black py-12 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <Link to="/" className="inline-flex items-center text-green-400 hover:text-green-300 mb-4">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Ana Sayfaya Dön
            </Link>
            <h1 className="text-4xl font-bold text-green-400">Müşteri Paneli</h1>
            <p className="text-gray-400 mt-2">Hoş geldiniz, {user.name}</p>
          </div>
        </div>

        {/* User Info */}
        <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-2xl p-6 mb-8">
          <h2 className="text-xl font-bold text-white mb-4">Hesap Bilgileri</h2>
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <p className="text-gray-400 text-sm">Ad Soyad</p>
              <p className="text-white font-semibold">{user.name}</p>
            </div>
            <div>
              <p className="text-gray-400 text-sm">Email</p>
              <p className="text-white font-semibold">{user.email}</p>
            </div>
          </div>
        </div>

        {/* Orders */}
        <div className="bg-gradient-to-br from-gray-900 to-black border border-green-500/30 rounded-2xl p-6">
          <div className="flex items-center mb-6">
            <Package className="w-6 h-6 text-green-400 mr-2" />
            <h2 className="text-xl font-bold text-white">Siparişlerim</h2>
          </div>

          {orders.length === 0 ? (
            <div className="text-center py-12">
              <Package className="w-16 h-16 text-gray-600 mx-auto mb-4" />
              <p className="text-gray-400 mb-4">Henüz siparişiniz bulunmamaktadır.</p>
              <Link to="/">
                <Button className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-black font-semibold">
                  Paketlere Göz At
                </Button>
              </Link>
            </div>
          ) : (
            <div className="space-y-4">
              {orders.map((order) => (
                <div
                  key={order.id}
                  className="bg-gray-800/50 rounded-xl p-6 border border-green-500/20 hover:border-green-500/40 transition-all"
                >
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                    <div className="flex-1 mb-4 md:mb-0">
                      <h3 className="text-lg font-bold text-white mb-1">{order.item.name}</h3>
                      <p className="text-gray-400 text-sm mb-2">
                        Tarih: {new Date(order.date).toLocaleDateString('tr-TR')}
                      </p>
                      <p className="text-green-400 font-semibold">{order.item.price} TL</p>
                    </div>
                    <div className={`inline-flex items-center px-4 py-2 rounded-lg border ${statusColor[order.status]}`}>
                      {statusIcon[order.status]}
                      <span className="ml-2 font-semibold">{statusText[order.status]}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;